var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.chipSelectOptions && _vm.chipSelectOptions.length > 0)?_c('ScChipSelect',{attrs:{"options":_vm.chipSelectOptions,"multiSelect":false,"labelProp":'chipLabel'},on:{"select":function($event){return _vm.catchLoyalty($event)}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }